import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App" }
const _hoisted_2 = { class: "App__tools" }
const _hoisted_3 = { class: "font" }
const _hoisted_4 = { class: "slider-container" }
const _hoisted_5 = { class: "slider" }
const _hoisted_6 = { class: "slider-container" }
const _hoisted_7 = { class: "slider" }
const _hoisted_8 = { class: "slider-container" }
const _hoisted_9 = { class: "slider" }
const _hoisted_10 = { class: "App__main" }

import { onMounted, ref, watch } from "vue";
import { getImage, getImageSize } from "@/tools/image";
import { CanvasData, Config, Size, Text, FontData } from "@/types";
import { addImage, getImageData, updateText } from "@/tools/canvas";
import { getPoints } from "@/tools/main";
import { drawCells, drawPoints, initSvg } from "@/tools/svg";
import { useDebounceFn } from "@vueuse/core";
import { loadFontToDocument } from "@/tools/font";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const config = ref<Config>({
    resolution: 99.5,
    n: 15000,
    stainedGlass: false,
});

const size = ref<Size>({ width: 1200, height: 600 });

const fonts = ref<FontData[]>([
    {
        name: "Merriweather",
        url: "url(fonts/Merriweather/Merriweather-Italic-VariableFont_opsz,wdth,wght.ttf)",
        style: "normal",
        weight: 400,
    },
    {
        name: "Knewave",
        url: "url(fonts/Knewave/Knewave-Regular.ttf)",
        style: "normal",
        weight: 400,
    },
    {
        name: "Roboto",
        url: "url(fonts/Roboto/Roboto-VariableFont_wdth,wght.ttf)",
        style: "normal",
        weight: 400,
    },
]);

const text = ref<Text>({
    content: "Code that loves design",
    size: 250,
    font: fonts.value[0].name,
});

const draw = async (context: CanvasRenderingContext2D, svgEl: SVGElement) => {
    const canvasData: CanvasData = { context, size: size.value };
    updateText(context, text.value, size.value);
    setTimeout(() => {
        const imageData = getImageData(canvasData);
        const points = getPoints(canvasData, imageData, config.value);
        const { pointsGroup, cellsGroup } = initSvg(svgEl);

        //drawPoints(pointsGroup, points);
        drawCells(cellsGroup, points, canvasData, config.value);
    }, 500);
};

const canvas = ref<HTMLCanvasElement | null>(null);
const svg = ref<SVGElement | null>(null);

const update = () => {
    if (canvas.value && svg.value) {
        const context = canvas.value.getContext("2d");
        if (context) {
            draw(context, svg.value);
        }
    }
};

const debouncedFn = useDebounceFn(() => {
    update();
}, 200);

const loadFonts = async () => {
    for (const font of fonts.value) {
        await loadFontToDocument(font);
    }
};

const init = async () => {
    await loadFonts();
    if (canvas.value && svg.value) {
        const context = canvas.value.getContext("2d");
        if (context) {
            context.canvas.width = size.value.width;
            context.canvas.height = size.value.height;
            svg.value.setAttribute("width", size.value.width.toString());
            svg.value.setAttribute("height", size.value.height.toString());
            draw(context, svg.value);
        }
    }
};

watch(() => config.value, debouncedFn, { deep: true });
watch(() => text.value, debouncedFn, { deep: true });

onMounted(() => {
    init();
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_slider = _resolveComponent("v-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text.value.content) = $event))
      }, null, 512), [
        [_vModelText, text.value.content]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_select, {
          items: fonts.value,
          modelValue: text.value.font,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((text.value.font) = $event)),
          label: "Font",
          "item-title": "name"
        }, null, 8, ["items", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_slider, {
            modelValue: text.value.size,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((text.value.size) = $event)),
            max: 500,
            min: 50,
            step: 1,
            "thumb-label": ""
          }, null, 8, ["modelValue"])
        ]),
        _cache[6] || (_cache[6] = _createTextVNode(" Font size ", -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_v_slider, {
            modelValue: config.value.resolution,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((config.value.resolution) = $event)),
            max: 100,
            min: 97,
            step: 0.1,
            "thumb-label": ""
          }, null, 8, ["modelValue"])
        ]),
        _cache[7] || (_cache[7] = _createTextVNode(" Precision ", -1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_slider, {
            modelValue: config.value.n,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((config.value.n) = $event)),
            max: 100000,
            min: 1000,
            step: 1000,
            "thumb-label": ""
          }, null, 8, ["modelValue"])
        ]),
        _cache[8] || (_cache[8] = _createTextVNode(" Number of points ", -1))
      ]),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((config.value.stainedGlass) = $event))
        }, null, 512), [
          [_vModelCheckbox, config.value.stainedGlass]
        ]),
        _cache[9] || (_cache[9] = _createTextVNode(" Stained glass ", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("canvas", {
        ref_key: "canvas",
        ref: canvas
      }, null, 512),
      (_openBlock(), _createElementBlock("svg", {
        ref_key: "svg",
        ref: svg
      }, null, 512))
    ])
  ]))
}
}

})